import React from 'react'
import Svg from '../Svg'
import { SvgProps } from '../types'

const Icon: React.FC<SvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 16 16" {...props}>
      <path
        d="M7.25467 8.92259L13.3331 2.84518V6.66667H15V0H8.33225V1.66667H12.1544L6.07597 7.74408L7.25467 8.92259ZM13.3355 13.3333V9.16667H11.6685V13.3333H1.66694V3.33334H5.83427V1.66667H1.66694C0.746312 1.66667 0 2.41286 0 3.33334V13.3333C0 14.2538 0.746312 15 1.66694 15H11.6685C12.5892 15 13.3355 14.2538 13.3355 13.3333Z"
        fill="#41BBD8"
      />
    </Svg>
  )
}

export default Icon
